import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutPageAccountDashboardComponent } from './layout-page-account-dashboard.component';



@NgModule({
  declarations: [
    LayoutPageAccountDashboardComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    LayoutPageAccountDashboardComponent
  ]
})
export class LayoutPageAccountDashboardModule { }
